var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "9.8px",
    height: "14px",
    viewBox: "0 0 9.8 14",
    enableBackground: "new 0 0 9.8 14",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-on",
    opacity: 0.4,
    enableBackground: "new    ",
    d: "M4.9,0C2.194,0,0,2.194,0,4.9 C0,8.575,4.9,14,4.9,14s4.9-5.425,4.9-9.1C9.8,2.194,7.607,0,4.9,0z M4.9,6.65c-0.966,0-1.75-0.784-1.75-1.75S3.934,3.15,4.9,3.15 c0.967,0,1.75,0.784,1.75,1.75l0,0C6.65,5.866,5.867,6.649,4.9,6.65z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location-on.4ca78691.svg";
export { ForwardRef as ReactComponent };